import React from 'react';
import './DiscoverTabs.css';

const DiscoverTabs = ({ activeTab, setActiveTab }) => (
  <div className="discover-tabs">
    <button
      className={`tab-button ${activeTab === 'users' ? 'active' : ''}`}
      onClick={() => setActiveTab('users')}
    >
      Language Partners
    </button>
    <button
      className={`tab-button ${activeTab === 'groups' ? 'active' : ''}`}
      onClick={() => setActiveTab('groups')}
    >
      Study Groups
    </button>
    <button
      className={`tab-button ${activeTab === 'events' ? 'active' : ''}`}
      onClick={() => setActiveTab('events')}
    >
      Events
    </button>
  </div>
);

export default DiscoverTabs;